export default __webpack_public_path__ + "static/codeholic-logo-8bb4ce09b0c7a8d23bbd8cc659d5d1f2.svg";